import appreceitaimg from '../data/images/appreceitaimg.png'
import trybewallet from '../data/images/trybewallet.png'
import brnshopcart from '../data/images/brnshopcart.png'

const projectsEN = [
	{
		thumb: appreceitaimg,
		name: 'Recipes App',
		description: 'A recipes app based on the world-renowned anime/manga "One Piece"',
		Stacks: 'Stacks: ReactJs, JS, HTML, CSS, Redux, Jest, RTL',
		site: 'https://baratie-recipesapp.netlify.app/',
		github: 'https://github.com/brunonegri/App-Recipe-Baratie'
	},
	{
		thumb: trybewallet,
		name: 'Trybe Wallet',
		description: 'An expense tracking and currency conversion application',
		Stacks: 'Stacks: ReactJs, JS, HTML, CSS, Redux',
		site: 'https://brntrybewallet.netlify.app/',
		github: 'https://github.com/brunonegri/BrN-Trybe-Wallet'
	},
	{
		thumb: brnshopcart,
		name: 'Shopping Cart',
		description: 'An application that simulates the use of E-Commerce',
		Stacks: 'Stacks: JS, HTML, CSS',
		site: 'https://brnshopcart.netlify.app/',
		github: 'https://github.com/brunonegri/Shopping-Cart'
	}
]

const projectsPTBR = [
	{
		thumb: appreceitaimg,
		name: 'App Receitas',
		description: 'Um aplicativo de receitas baseado no mangá/anime "One Piece"',
		Stacks: 'Tecnologias: ReactJs, JS, HTML, CSS, Redux, Jest, RTL',
		site: 'https://baratie-recipesapp.netlify.app/',
		github: 'https://github.com/brunonegri/App-Recipe-Baratie'
	},
	{
		thumb: trybewallet,
		name: 'Trybe Wallet',
		description: 'Uma aplicação de carteira e conversão de moedas',
		Stacks: 'Tecnologias: ReactJs, JS, HTML, CSS, Redux',
		site: 'https://brntrybewallet.netlify.app/',
		github: 'https://github.com/brunonegri/BrN-Trybe-Wallet'
	},
	{
		thumb: brnshopcart,
		name: 'Carrinho de Compras',
		description: 'Uma aplicação que simula o uso do carrinho de compras de um E-Commerce',
		Stacks: 'Tecnologias: JS, HTML, CSS',
		site: 'https://brnshopcart.netlify.app/',
		github: 'https://github.com/brunonegri/Shopping-Cart'
	}
]

export {projectsEN, projectsPTBR}

